import { render, staticRenderFns } from "./DiadaForm.vue?vue&type=template&id=117244af&scoped=true&lang=pug&"
import script from "./DiadaForm.vue?vue&type=script&lang=js&"
export * from "./DiadaForm.vue?vue&type=script&lang=js&"
import style0 from "./DiadaForm.vue?vue&type=style&index=0&id=117244af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117244af",
  null
  
)

export default component.exports